import {createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest } from '../generalRequest';

const initialState = {
    banks: [],
    bankId: '',
    selectedBank: {},
    componentToDisplay : '',
    message: '',
    cardOnFilePaymentValue : '',
    isLoading: false,
    shouldDisplayConfirmationCodeTextField: false,
    shouldDisplayOtpPrompt: false,
    creditAccountId: '',
    shouldDisplayIFrame: false,
    creditCardPaymentUrl: '',
    banksIbanData: [],
    cards: [],
    isCardSuccessfullyAdded: false,
    isCardSuccessfullyRemoved: false,
    shouldFetchCards: false,
    isCardOnFileTopUpSuccessfullyCompleted : false,
    currentAction: '',
    selectedCard: '',
    otp: '',
    isDirectDebitTransactionSuccessfullyCompleted: false,
    shouldDisplayTopUpLocationsIFrame : false,
    cardOnFileExplanationText : ''
};

export const topUpSlice = createSlice({
    name: 'topUp',
    initialState,
    reducers:
    {
        resetTopUpMessage: (state) => {
            state.message = ''
        },
        setShouldFetchCards: (state, action) => 
        {
            state.shouldFetchCards = action.payload
        },
        resetTopUpSlice:() => initialState,

        setShouldDisplayOtpPrompt: (state, action) => 
        {
            state.shouldDisplayOtpPrompt = action.payload
        },
        setCardOnFilePaymentValue: (state, action) => 
        {
            state.cardOnFilePaymentValue = action.payload
        },
        setBanks: (state, action) => 
        {
            state.banks = action.payload
        },
        setIsCardOnFileTopUpSuccessfullyCompleted: (state, action) => 
        {
            state.isCardOnFileTopUpSuccessfullyCompleted = action.payload
        },
        setCurrentAction: (state, action) => 
        {
            state.currentAction = action.payload
        },
        setSelectedCard: (state, action) => 
        {
            state.selectedCard = action.payload
        },
        setCards: (state, action) =>
        {
            state.cards = action.payload
        },
        setSelectedBank: (state, action) => 
        {
            state.selectedBank = action.payload
        },
        setIsCardSuccessfullyRemoved : (state, action) => 
        {
            state.isCardSuccessfullyRemoved = action.payload
        },
        setShouldDisplayIFrame: (state, action) =>
        {
            state.shouldDisplayIFrame = action.payload
        },
        setIsCardSuccessfullyAdded: (state, action) => 
        {
            state.isCardSuccessfullyAdded = action.payload
        },
        setShouldDisplayConfirmationCodeTextField: (state, action) => 
        {
            state.shouldDisplayConfirmationCodeTextField = action.payload
        },
        setIsDirectDebitTransactionSuccessfullyCompleted: (state, action) => 
        {
            state.isDirectDebitTransactionSuccessfullyCompleted = action.payload
        },
        setShouldDisplayTopUpLocationsIFrame: (state, action) => 
        {
            state.shouldDisplayTopUpLocationsIFrame = action.payload
        }    
    },       
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'DirectDebit/CreditAccount')
                {
                    state.shouldDisplayConfirmationCodeTextField = true
                    state.message = action.payload.response.Message
                    state.creditAccountId = action.payload.response.CreditAccountId
                    // state.otp = action.payload.response.Otp
                }  
                else if(action.payload.endpoint === 'GetAccountBankInfo')
                { 
                    state.banks = action.payload.response.BankInfo
                    state.bankId = action.payload.response.BankID
                }
                else if(action.payload.endpoint === 'DirectDebit/ConfirmDirectDebitCredit')
                { 
                    state.message = action.payload.response.Message
                    state.isDirectDebitTransactionSuccessfullyCompleted = true
                }
                else if(action.payload.endpoint === 'DirectDebit/AddBankAccount')
                { 
                    state.selectedBank.isPending = true
                }   
                else if(action.payload.endpoint === 'CreditBalance')
                {
                    state.creditCardPaymentUrl = action.payload.response.redirectURL
                    state.shouldDisplayIFrame = true
                }
                else if(action.payload.endpoint === 'GetBanksIban')
                {
                   state.banksIbanData = action.payload.response.ibans
                }
                else if(action.payload.endpoint === 'GetRegisteredCards')
                {
                    state.cards = action.payload.response.cardInfo
                    state.cardOnFileExplanationText = action.payload.response.text
                    if(state.cards.length > 0)
                    {
                        state.selectedCard = state.cards[0].cardID
                    } 

                    // state.cards = action.payload.response.cardInfo.map(card => {
                    //     return {...card, isSelected: false}
                    // })
                    // if(state.cards.length > 0)
                    // {
                    //     state.cards[0].isSelected = true
                    //     state.selectedCard = state.cards[0]
                    // }
                }
                // else if(action.payload.endpoint === 'AddCard')
                // {
                //     state.isCardSuccessfullyAdded = true
                // }
                else if(action.payload.endpoint === 'RemoveCard')
                {
                    //state.isCardSuccessfullyRemoved = true
                    state.shouldFetchCards = true
                }
                else if(action.payload.endpoint === 'StartCardsOnFile')
                {
                    state.shouldDisplayOtpPrompt = true
                }
                else if(action.payload.endpoint === 'CreditBalanceCardsOnFile')
                { 
                    state.shouldDisplayOtpPrompt = false
                    state.isCardOnFileTopUpSuccessfullyCompleted = true
                }                                           
            })   
    },
})

export const { setBanks, setShouldDisplayOtpPrompt,resetTopUpSlice, setSelectedBank,setCardOnFilePaymentValue, setCards, setIsCardOnFileTopUpSuccessfullyCompleted, setIsCardSuccessfullyRemoved, setShouldFetchCards, setIsCardSuccessfullyAdded, setSelectedCard,setCurrentAction, addBankAccount,setShouldDisplayTopUpLocationsIFrame, resetTopUpMessage, setShouldDisplayIFrame, setShouldDisplayConfirmationCodeTextField, setIsDirectDebitTransactionSuccessfullyCompleted} = topUpSlice.actions;

export const selectTopUpData = (state) => state.topUp;

export default topUpSlice.reducer;


